import { alpha, Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles<Theme>(({ palette }) => {
  return {
    priceHelperRoot: {
      color: alpha(palette.common.black, 0.6),
      fontSize: 13,
    },
  };
});

export default useStyles;
